import { Injectable } from '@angular/core';
import { map } from 'rxjs';

import { Store } from '../../../../shared/store';
import { SearchedTermState } from './searched-term.state';

const searchedTermState = new SearchedTermState();

@Injectable({ providedIn: 'root' })
export class SearchedTermStore extends Store<SearchedTermState> {
  searchedTerm$ = this.state$.pipe(map((s) => s.searchedTerm));

  constructor() {
    super(searchedTermState);
  }

  // SET DATA

  setSearchedTerm(nextSearchedTerm: string): void {
    if (this.state.searchedTerm === nextSearchedTerm) {
      return;
    }
    this.setState({ ...this.state, searchedTerm: nextSearchedTerm });
  }
}
